import React from "react";
import TeamsManagementWorkspace from "../../components/TeamsManagementWorkspace";

export default function AddManageTeamsPage() {
  return (
    <TeamsManagementWorkspace
      title="Add & Manage Teams"
      subtitle="Split organization administration from user administration, with modal editing and cleaner tables."
      eyebrow="Super Admin"
      icon="orgs"
      showOrgTab
    />
  );
}
